<div class="flex w-full flex-col p-4">
  <div class="flex flex-col justify-center">
    <h2>Screenshare with Video</h2>
    <app-select-camera-input-button (selection)="updateDeviceId($event)" />
    <div class="flex flex-row justify-between gap-2">
      <div class="view">
        <p>Camera Stream</p>
        <video #camera controls autoplay muted></video>
      </div>

      <div class="view">
        <p>Screen Stream</p>
        <video #screen controls autoplay muted></video>
      </div>
    </div>
    <div class="remote">
      <div class="view">
        <p>Remote Composed Stream</p>
        <video #remote controls autoplay></video>
      </div>
    </div>
    <div class="controls">
      @if (isStart) {
        <button class="bg-red-400" (click)="stop()">Stop</button>
      }
      @if (!isStart) {
        <button class="bg-green-400" (click)="start()">Start</button>
      }
    </div>
  </div>
</div>
